import { useState } from "react";
import { useMutation } from "@tanstack/react-query";

//Common
import { Snackbar } from "../../common/VFX-UI";

//App
import ChangePassword from "./ChangePassword";
import { ChangePasswordViewModel } from "../../../viewModels/changePasswordViewModel";
import { ChangePasswordFormContainerProps } from "../../../types/user";
import { ChangePasswordDto } from "../../../app/model/api/types/dto/changePasswordDto";
import userApi from "../../../app/model/api/userApi";
import { apiErrorMessage } from "../../../utility/lib/error";
import { SnackbarState } from "../../../types";
import { getClaims } from "../../../utility/tokenHelper";

function ChangePasswordContainer(props: ChangePasswordFormContainerProps) {
  const { onClose, onShowSuccess } = props;

  const [snackbar, setSnackbar] = useState<SnackbarState>({
    showErrorSnackbar: false,
    errorMessage: "",
  });

  const successMessage = "Password updated";
  const claims = getClaims();

  const onShowErrorSnackbar = (errorMessage: string) => {
    setSnackbar({
      showErrorSnackbar: true,
      errorMessage,
    });
  };

  const onCloseSnackbar = () => {
    setSnackbar({
      showErrorSnackbar: false,
      errorMessage: "",
    });
  };

  const { mutate } = useMutation<void, Error, ChangePasswordDto>({
    mutationFn: async (payload: ChangePasswordDto) => {
      const response = await userApi.changePassword(payload);
      const errorMessage = apiErrorMessage(response.errorMessages);
      if (errorMessage) {
        onShowErrorSnackbar(errorMessage);
      } else {
        onShowSuccess(successMessage);
      }
    },
    onError: (response:  any) => {
        const errorMessage = apiErrorMessage(response.errorMessages);
        if (errorMessage) {
            onShowErrorSnackbar(errorMessage);
        }
      }
  });

  const handleOnSubmit = async (values: ChangePasswordViewModel) => {
    const payload: ChangePasswordDto = values.toDto();
    mutate(payload);
  };

  const initialValues = new ChangePasswordViewModel(null, null, null);

  return (
    <>
      <ChangePassword
        onClose={onClose}
        handleOnSubmit={handleOnSubmit}
        initialVal={initialValues}
        status={""}
      />
      {snackbar.showErrorSnackbar && (
        <Snackbar
          open={true}
          message={snackbar.errorMessage}
          handleClose={onCloseSnackbar}
          severity="danger"
        />
      )}
    </>
  );
}

export default ChangePasswordContainer;
